(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 87314:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(25353);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 25353:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ./components/shared/HeadMetadata.tsx
var HeadMetadata = __webpack_require__(73412);
// EXTERNAL MODULE: ./components/layout/Page.tsx + 19 modules
var Page = __webpack_require__(24882);
// EXTERNAL MODULE: ../../node_modules/next/dynamic.js
var dynamic = __webpack_require__(25237);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ../ui-library/dist/index.js + 203 modules
var dist = __webpack_require__(78197);
// EXTERNAL MODULE: ../../node_modules/@fortawesome/pro-light-svg-icons/index.mjs
var pro_light_svg_icons = __webpack_require__(38914);
// EXTERNAL MODULE: ./components/CardHighlight02/CardHighlight02.tsx + 1 modules
var CardHighlight02 = __webpack_require__(18408);
// EXTERNAL MODULE: ./components/CardHighlight03/CardHighlight03.tsx + 1 modules
var CardHighlight03 = __webpack_require__(13917);
// EXTERNAL MODULE: ./components/layout/Page.styled.tsx
var Page_styled = __webpack_require__(29242);
// EXTERNAL MODULE: ./components/shared/HtmlTrans.tsx
var HtmlTrans = __webpack_require__(97210);
// EXTERNAL MODULE: ./hooks/useI18n/index.ts + 1 modules
var useI18n = __webpack_require__(39105);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var router = __webpack_require__(5632);
// EXTERNAL MODULE: ./utils/paths.tsx
var paths = __webpack_require__(64516);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 1 modules
var styled_components_browser_esm = __webpack_require__(40286);
// EXTERNAL MODULE: ./theme/index.js + 247 modules
var theme = __webpack_require__(90408);
;// CONCATENATED MODULE: ./features/public-home/features/HomeV2Features.styled.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: #faf9ff;\n  color: #433f52;\n  padding: 24px 1rem;\n  font-size: ",
        ";\n  display: flex;\n  flex-direction: column;\n  gap: 3rem;\n\n  @media (min-width: ",
        ") {\n    padding: 64px 0;\n  }\n\n  img {\n    display: block;\n    margin: 0 auto;\n\n    &.md {\n      display: block;\n    }\n\n    &.lg {\n      display: none;\n    }\n\n    @media (min-width: ",
        ") {\n      &.md {\n        display: none;\n      }\n\n      &.lg {\n        display: block;\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: ",
        ";\n  margin: 0 auto 3rem auto;\n\n  h2 {\n    margin-top: 0;\n    font-size: ",
        ";\n    text-wrap: balance;\n  }\n\n  p {\n    font-size: ",
        ";\n    line-height: 1.75;\n    max-width: ",
        ";\n    margin: 0 auto;\n  }\n\n  p:first-child {\n    font-size: ",
        ";\n    font-weight: 800;\n    margin-bottom: 0;\n  }\n\n  p:last-child {\n    margin: 0 auto;\n  }\n\n  @media (min-width: ",
        ") {\n    text-align: center;\n\n    h2 {\n      font-size: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n  line-height: 1.75;\n  font-size: ",
        ";\n\n  h3 {\n    font-size: ",
        ";\n    line-height: 1.25;\n  }\n\n  img {\n    max-width: 100%;\n    margin: 0 auto;\n  }\n\n  @media (min-width: ",
        ") {\n    flex-direction: row;\n    align-items: center;\n    gap: 4rem;\n    font-size: ",
        ";\n\n    h3 {\n      font-size: ",
        ";\n    }\n\n    img {\n      max-width: 40%;\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  line-height: 1.75;\n\n  h3 {\n    margin: 0 0 0.5rem 0;\n    font-size: ",
        ";\n    font-weight: 700;\n    line-height: 1.25;\n  }\n\n  p {\n    margin-top: 0;\n    font-size: ",
        ";\n  }\n\n  p:last-child {\n    margin-bottom: 0;\n  }\n\n  @media (min-width: ",
        ") {\n    max-width: ",
        ";\n    text-align: ",
        ";\n    margin: 0 auto;\n\n    h3 {\n      font-size: ",
        ";\n    }\n\n    p {\n      font-size: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n\n  @media (min-width: ",
        ") {\n    flex-direction: row;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.5rem;\n  line-height: 1.75;\n  font-size: ",
        ";\n\n  img {\n    max-width: 100%;\n  }\n\n  h3 {\n    font-size: ",
        ";\n    line-height: 1.25;\n    color: #092c61;\n    margin-bottom: 0;\n  }\n\n  p {\n    margin-top: 0;\n  }\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n\n    h3 {\n      font-size: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 4rem;\n\n  @media (min-width: ",
        ") {\n    grid-template-columns: 1fr 1fr;\n  }\n\n  @media (min-width: ",
        ") {\n    grid-template-columns: 1fr 1fr 1fr;\n    gap: 2rem;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: row;\n  gap: 0.75rem;\n  align-items: flex-start;\n\n  svg {\n    color: #c082d1;\n    max-height: 40px;\n  }\n\n  strong {\n    line-height: 1;\n    font-weight: 900;\n    font-size: ",
        ";\n    margin-bottom: 0;\n\n    span {\n      font-weight: 400;\n      font-size: ",
        ";\n    }\n  }\n\n  span {\n    font-size: ",
        ";\n  }\n\n  @media (min-width: ",
        ") {\n    strong {\n      font-size: ",
        ";\n    }\n\n    span {\n      font-size: ",
        ";\n    }\n\n    svg {\n      max-height: 64px;\n    }\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}


var Root = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-68cbb81e-0"
})(_templateObject(), (0,theme/* fontSize */.JB)("lg"), (0,theme/* screen */.sp)("lg"), (0,theme/* screen */.sp)("lg"));
var Intro = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-68cbb81e-1"
})(_templateObject1(), (0,theme/* container */.nC)("lg"), (0,theme/* fontSize */.JB)("xl2"), (0,theme/* fontSize */.JB)("md"), (0,theme/* container */.nC)("sm"), (0,theme/* fontSize */.JB)("lg"), (0,theme/* screen */.sp)("lg"), (0,theme/* fontSize */.JB)("xl4"));
var WhatCards = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-68cbb81e-2"
})(_templateObject2(), (0,theme/* fontSize */.JB)("md"), (0,theme/* fontSize */.JB)("lg"), (0,theme/* screen */.sp)("lg"), (0,theme/* fontSize */.JB)("lg"), (0,theme/* fontSize */.JB)("xl3"));
var TalkCards = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-68cbb81e-3"
})(_templateObject3(), (0,theme/* fontSize */.JB)("lg"), (0,theme/* fontSize */.JB)("xl"), (0,theme/* fontSize */.JB)("md"), (0,theme/* screen */.sp)("lg"), function(param) {
    var align = param.align;
    return align === "center" ? "55%" : "100%";
}, function(param) {
    var align = param.align;
    return align || "left";
}, (0,theme/* fontSize */.JB)("xl3"), (0,theme/* fontSize */.JB)("lg"));
var HowCardsWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-68cbb81e-4"
})(_templateObject4(), (0,theme/* screen */.sp)("lg"));
var HowCards = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-68cbb81e-5"
})(_templateObject5(), (0,theme/* fontSize */.JB)("md"), (0,theme/* fontSize */.JB)("lg"), (0,theme/* screen */.sp)("lg"), (0,theme/* fontSize */.JB)("lg"), (0,theme/* fontSize */.JB)("xl3"));
var DataStack = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-68cbb81e-6"
})(_templateObject6(), (0,theme/* screen */.sp)("md"), (0,theme/* screen */.sp)("lg"));
var DataItem = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-68cbb81e-7"
})(_templateObject7(), (0,theme/* fontSize */.JB)("xl2"), (0,theme/* fontSize */.JB)("xl"), (0,theme/* fontSize */.JB)("md"), (0,theme/* screen */.sp)("lg"), (0,theme/* fontSize */.JB)("xl4"), (0,theme/* fontSize */.JB)("lg"));
var Features = {
    Root: Root,
    Intro: Intro,
    WhatCards: WhatCards,
    TalkCards: TalkCards,
    HowCardsWrapper: HowCardsWrapper,
    HowCards: HowCards,
    DataItem: DataItem,
    DataStack: DataStack
};

;// CONCATENATED MODULE: ./features/public-home/features/HomeV2Features.tsx











var HomeV2Features = function(param) {
    var manfreditesCount = param.manfreditesCount, stats = param.stats;
    var t = (0,useI18n/* useI18n */.Q)("home-v2").t;
    var locale = (0,router.useRouter)().locale;
    var currentStats = stats[0];
    var data = [
        {
            value: manfreditesCount.toLocaleString(locale),
            key: t("home-v2.features.data.data-01"),
            icon: pro_light_svg_icons/* faUsers */.FVb
        },
        {
            value: (currentStats === null || currentStats === void 0 ? void 0 : currentStats.attributes) ? currentStats.attributes.successRate + "%" : null,
            key: t("home-v2.features.data.data-02"),
            icon: pro_light_svg_icons/* faThumbsUp */.u8Q
        },
        {
            value: (currentStats === null || currentStats === void 0 ? void 0 : currentStats.attributes) ? currentStats.attributes.timeToHire : null,
            key: t("home-v2.features.data.data-03"),
            append: t("home-v2.features.data.days"),
            icon: pro_light_svg_icons/* faCalendar */.fT7
        },
        {
            value: (currentStats === null || currentStats === void 0 ? void 0 : currentStats.attributes) ? "+" + currentStats.attributes.positionsCount.toLocaleString(locale) : null,
            key: t("home-v2.features.data.data-04"),
            icon: pro_light_svg_icons/* faMegaphone */.AuT
        },
        {
            value: (currentStats === null || currentStats === void 0 ? void 0 : currentStats.attributes) ? currentStats.attributes.customerScore.toLocaleString(locale) : null,
            key: t("home-v2.features.data.data-05"),
            icon: pro_light_svg_icons/* faSmile */.ctA
        },
        {
            value: (currentStats === null || currentStats === void 0 ? void 0 : currentStats.attributes) ? "+" + currentStats.attributes.companiesCount.toLocaleString(locale) : null,
            key: t("home-v2.features.data.data-06"),
            icon: pro_light_svg_icons/* faBuilding */.P88
        }
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Features.Root, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Page_styled/* PageContentContainer */.R, {
                containerSize: "xl",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Features.Intro, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: t("home-v2.features.what.subtitle")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Header */.h4, {
                                editorial: true,
                                as: "h2",
                                size: "5xl",
                                children: t("home-v2.features.what.title")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Stack */.Kq, {
                        direction: "column",
                        gap: "3xl",
                        children: Array.from({
                            length: 3
                        }).map(function(_, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(CardHighlight03/* CardHighlight03 */.u, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Features.WhatCards, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            loading: "lazy",
                                            src: (0,paths/* getPublicPath */.A)("/images/home-v2/home-v2-features-what-card-0".concat(index + 1, ".webp")),
                                            alt: ""
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* StackItem */.vO, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                    children: t("home-v2.features.what.card-0".concat(index + 1, ".title"))
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                                                    ns: "home-v2",
                                                    i18nKey: "home-v2.features.what.card-0".concat(index + 1, ".desc")
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }, index);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Page_styled/* PageContentContainer */.R, {
                containerSize: "xl",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Features.Intro, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: t("home-v2.features.talk.subtitle")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Header */.h4, {
                                editorial: true,
                                as: "h2",
                                size: "5xl",
                                children: t("home-v2.features.talk.title")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CardHighlight02/* CardHighlight02 */.e, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Stack */.Kq, {
                            direction: "column",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    loading: "lazy",
                                    src: (0,paths/* getPublicPath */.A)("/images/home-v2/home-v2-features-talk-card-01.webp"),
                                    alt: "",
                                    className: "lg"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    loading: "lazy",
                                    className: "md",
                                    src: (0,paths/* getPublicPath */.A)("/images/home-v2/home-v2-features-talk-card-01-md.webp"),
                                    alt: ""
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Features.TalkCards, {
                                    align: "center",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* StackItem */.vO, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                                            ns: "home-v2",
                                            i18nKey: "home-v2.features.talk.card-01.desc"
                                        })
                                    })
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Page_styled/* PageContentContainer */.R, {
                containerSize: "xl",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Features.Intro, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: t("home-v2.features.data.subtitle")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Header */.h4, {
                                editorial: true,
                                as: "h2",
                                size: "5xl",
                                children: t("home-v2.features.data.title")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Features.DataStack, {
                        children: data.map(function(param, index) {
                            var key = param.key, value = param.value, append = param.append, icon = param.icon;
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Features.DataItem, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Icon */.JO, {
                                        icon: icon,
                                        size: "6xl"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Stack */.Kq, {
                                        direction: "column",
                                        gap: "xs",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("strong", {
                                                children: [
                                                    value,
                                                    !!append && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: append
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: key
                                            })
                                        ]
                                    })
                                ]
                            }, index);
                        })
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ../../node_modules/@fortawesome/pro-solid-svg-icons/index.mjs
var pro_solid_svg_icons = __webpack_require__(54933);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./utils/app-urls.ts
var app_urls = __webpack_require__(62177);
;// CONCATENATED MODULE: ./features/public-home/hero/HomeV2Hero.styled.ts

function HomeV2Hero_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: #d7edf1;\n  color: #092c61;\n  padding: 24px 0;\n  font-size: ",
        ";\n\n  .titles {\n    flex-direction: column-reverse;\n  }\n"
    ]);
    HomeV2Hero_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function HomeV2Hero_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: url('/images/home-v2/home-v2-hero-bg.svg') no-repeat top center;\n  background-size: cover;\n  padding: 3rem;\n\n  text-align: center;\n  color: #fff;\n\n  font-weight: 800;\n\n  p {\n    margin: 0;\n  }\n\n  img {\n    max-width: 95%;\n    margin: 0 auto;\n  }\n\n  h2 {\n    font-size: ",
        " !important;\n    font-weight: 800;\n    text-wrap: balance;\n  }\n\n  @media (min-width: ",
        ") {\n    padding: 100px 14rem;\n    background-size: contain;\n\n    h2 {\n      font-size: ",
        " !important;\n      font-weight: 800;\n    }\n  }\n"
    ]);
    HomeV2Hero_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function HomeV2Hero_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: center;\n  font-size: ",
        ";\n\n  h3 {\n    font-weight: 800;\n    text-transform: uppercase;\n  }\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n"
    ]);
    HomeV2Hero_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function HomeV2Hero_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: ",
        ";\n  overflow: hidden;\n  position: relative;\n\n  @media (min-width: ",
        ") {\n    height: ",
        ";\n  }\n\n  &::before,\n  &::after {\n    content: '';\n    height: ",
        ";\n    position: absolute;\n    width: ",
        ";\n    z-index: 2;\n    color: rgb(215, 237, 241);\n    background: linear-gradient(\n      to right,\n      rgba(215, 237, 241, 1) 0%,\n      rgba(250, 249, 255, 0) 100%\n    );\n  }\n\n  &::after {\n    right: 0;\n    top: 0;\n    transform: rotateZ(180deg);\n  }\n\n  &::before {\n    left: 0;\n    top: 0;\n  }\n\n  > div {\n    animation: scroll 40s linear infinite;\n    display: flex;\n    gap: ",
        ";\n  }\n\n  &.reverse > div {\n    animation-direction: reverse;\n  }\n\n  @keyframes scroll {\n    0% {\n      transform: translateX(0);\n    }\n    100% {\n      transform: translateX(-100%);\n    }\n  }\n"
    ]);
    HomeV2Hero_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function HomeV2Hero_styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-shrink: 0;\n  height: ",
        ";\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  @media (min-width: ",
        ") {\n    height: ",
        ";\n  }\n\n  img {\n    height: ",
        ";\n    width: auto;\n    display: block;\n    filter: grayscale(100%);\n\n    @media (min-width: ",
        ") {\n      height: ",
        ";\n    }\n  }\n"
    ]);
    HomeV2Hero_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}


var HomeV2Hero_styled_Root = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-369e5cc2-0"
})(HomeV2Hero_styled_templateObject(), (0,theme/* fontSize */.JB)("lg"));
var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-369e5cc2-1"
})(HomeV2Hero_styled_templateObject1(), (0,theme/* fontSize */.JB)("xl3"), (0,theme/* screen */.sp)("lg"), (0,theme/* fontSize */.JB)("xl5"));
var Customers = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-369e5cc2-2"
})(HomeV2Hero_styled_templateObject2(), (0,theme/* fontSize */.JB)("md"), (0,theme/* screen */.sp)("lg"), (0,theme/* fontSize */.JB)("lg"));
var StyledLogos = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-369e5cc2-3"
})(HomeV2Hero_styled_templateObject3(), (0,theme/* spacing */.W0)("xl"), (0,theme/* screen */.sp)("lg"), (0,theme/* spacing */.W0)("xl3"), (0,theme/* spacing */.W0)("xl3"), (0,theme/* spacing */.W0)("xl5"), (0,theme/* spacing */.W0)("xl5"));
var StyledLogoItem = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-369e5cc2-4"
})(HomeV2Hero_styled_templateObject4(), (0,theme/* spacing */.W0)("xl"), (0,theme/* screen */.sp)("lg"), (0,theme/* spacing */.W0)("xl3"), (0,theme/* spacing */.W0)("mdlg"), (0,theme/* screen */.sp)("lg"), (0,theme/* spacing */.W0)("xl2"));
var Hero = {
    Root: HomeV2Hero_styled_Root,
    Wrapper: Wrapper,
    Customers: Customers,
    StyledLogos: StyledLogos,
    StyledLogoItem: StyledLogoItem
};

;// CONCATENATED MODULE: ./features/public-home/hero/HomeV2Hero.tsx











var HomeV2Hero = function(param) {
    var customers = param.customers;
    var t = (0,useI18n/* useI18n */.Q)("home-v2").t;
    var locale = (0,router.useRouter)().locale;
    var filteredRow = function(e) {
        return customers.filter(function(el) {
            if (el.attributes.row === e) {
                return el;
            }
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Hero.Root, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Page_styled/* PageContentContainer */.R, {
            containerSize: "xlMax",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Hero.Wrapper, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Stack */.Kq, {
                        direction: "column",
                        gap: "3xl",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Stack */.Kq, {
                                direction: "column-reverse",
                                className: "titles",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Header */.h4, {
                                        editorial: true,
                                        as: "h2",
                                        size: "5xl",
                                        children: t("home-v2.hero.title")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: t("home-v2.hero.subtitle")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Stack */.Kq, {
                                contentAlign: "center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: (0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.companies */.uu.companies, locale),
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* ButtonLink */.ZP, {
                                            schema: "brand1",
                                            variant: "hard",
                                            startIcon: pro_solid_svg_icons/* faBuilding */.P88,
                                            size: "s",
                                            label: t("home-v2.hero.cta-company")
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: (0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.talent */.uu.talent, locale),
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* ButtonLink */.ZP, {
                                            schema: "brand1",
                                            variant: "ghost",
                                            size: "s",
                                            startIcon: pro_light_svg_icons/* faUserAstronaut */.KCX,
                                            label: t("home-v2.hero.cta-candidate")
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: (0,paths/* getPublicPath */.A)("/images/home-v2/home-v2-hero-screenshot.webp"),
                                alt: "",
                                width: "904",
                                height: "571"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Hero.Customers, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Stack */.Kq, {
                        direction: "column",
                        gap: "xl",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                children: t("home-v2.hero.work-with-us")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Hero.StyledLogos, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    children: [
                                        filteredRow(1).sort(function(a, b) {
                                            return a.attributes.orderInTheRow - b.attributes.orderInTheRow;
                                        }).map(function(item, index) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Hero.StyledLogoItem, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: item.attributes.logo.data.attributes.url,
                                                    alt: item.attributes.companyName
                                                })
                                            }, index);
                                        }),
                                        filteredRow(1).sort(function(a, b) {
                                            return a.attributes.orderInTheRow - b.attributes.orderInTheRow;
                                        }).map(function(item, index) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Hero.StyledLogoItem, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: item.attributes.logo.data.attributes.url,
                                                    alt: item.attributes.companyName
                                                })
                                            }, index);
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Hero.StyledLogos, {
                                className: "reverse",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    children: [
                                        filteredRow(2).sort(function(a, b) {
                                            return a.attributes.orderInTheRow - b.attributes.orderInTheRow;
                                        }).map(function(item, index) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Hero.StyledLogoItem, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: item.attributes.logo.data.attributes.url,
                                                    alt: item.attributes.companyName
                                                })
                                            }, index);
                                        }),
                                        filteredRow(2).sort(function(a, b) {
                                            return a.attributes.orderInTheRow - b.attributes.orderInTheRow;
                                        }).map(function(item, index) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Hero.StyledLogoItem, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: item.attributes.logo.data.attributes.url,
                                                    alt: item.attributes.companyName
                                                })
                                            }, index);
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: t("home-v2.hero.many-more")
                            })
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var hero_HomeV2Hero = (HomeV2Hero);

;// CONCATENATED MODULE: ./features/public-home/HomeV2Page.tsx





var HomeV2Form = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(3955), __webpack_require__.e(1534), __webpack_require__.e(2987), __webpack_require__.e(6248), __webpack_require__.e(3462)]).then(__webpack_require__.bind(__webpack_require__, 35127));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(35127)
            ];
        }
    },
    ssr: false
});
var HomeV2Community = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 9744).then(__webpack_require__.bind(__webpack_require__, 39744));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(39744)
            ];
        }
    },
    ssr: false
});
var HomeV2Page = function(param) {
    var bannerText = param.bannerText, manfreditesCount = param.manfreditesCount, stats = param.stats, customers = param.customers;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Page/* default */.ZP, {
        hasScrollTop: true,
        pageVariant: "landing",
        bannerText: bannerText,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(hero_HomeV2Hero, {
                customers: customers
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeV2Features, {
                manfreditesCount: manfreditesCount,
                stats: stats
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeV2Community, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeV2Form, {})
        ]
    });
};

// EXTERNAL MODULE: ./hooks/usePageTrack/index.ts + 1 modules
var usePageTrack = __webpack_require__(56002);
;// CONCATENATED MODULE: ./pages/index.tsx







var LandingPage = function(param) {
    var baseUrl = param.baseUrl, bannerText = param.bannerText, manfreditesCount = param.manfreditesCount, stats = param.stats, customers = param.customers;
    var t = (0,useI18n/* useI18n */.Q)("home-v2").t;
    (0,usePageTrack/* usePageTrack */.N)("Website - Page Loaded");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeadMetadata/* default */.Z, {
                title: t("home-v2.page_title"),
                desc: t("home-v2.page_description"),
                url: app_urls/* APP_URLS.home */.uu.home,
                imgUrl: "".concat(baseUrl).concat((0,paths/* getPublicPath */.A)("/images/cards/card_homeV2.png")),
                indexable: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeV2Page, {
                bannerText: bannerText,
                manfreditesCount: manfreditesCount,
                stats: stats,
                customers: customers
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var pages = (LandingPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7482,625,4882,5890,9774,2888,179], function() { return __webpack_exec__(87314); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);